import SectionSubtitle from '../../../../components/SectionSubtitle';
import SectionTitle from '../../../../components/SectionTitle';
import style from './Map.module.scss';
import video from './assets/video.mp4';
import videoWebm from './assets/video.webm';

const MapSection = () => {
  return (
    <section className={style.map}>
      <div className='container'>
        <SectionTitle>Global Presence</SectionTitle>
        <SectionSubtitle>
          Fully <span>remote team</span> working seamlessly from different
          countries, and ensuring{' '}
          <span>constant interaction with the markets.</span> <br /> Our
          technical infrastructure <span>minimizes latency</span> and enables
          reliable connection to exchanges.
        </SectionSubtitle>
        <div className={style.mapVideo}>
          <video
            preload='none'
            playsInline
            webkit-playsInline
            loop
            autoPlay
            muted
          >
            <source src={videoWebm} />
            <source src={video} />
          </video>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
